<template>
  <div class="p-col-12">
    <div class="card">
      <h5>Usuarios</h5>
      <router-link to="/usuarios/create">
        <Button label="Nuevo" style="width: 10rem" />
      </router-link>
      <DataTable
        :value="items"
        scrollHeight="400px"
        :loading="loading2"
        scrollDirection="both"
        class="p-mt-3"
      >
        <Column field="userName" header="User Name"></Column>
        <Column field="email" header="Email"></Column>
        <Column field="empresa.name" header="Empresa"></Column>
        <Column field="emailConfirmed" header="Email Confirmado">
          <template #body="{data}">
            <span class="p-column-title">Email Confirmado</span>
            <span
              :class="
                'empresa-badge status-' +
                  (data.emailConfirmed ? 'active' : 'inactive')
              "
              >{{ data.emailConfirmed ? 'Confirmado' : 'No confirmado' }}</span
            >
          </template>
        </Column>
        <Column
          header="Acciones"
          :exportable="false"
          :style="{ width: '200px' }"
          bodyClas="p-ml-auto"
        >
          <template #body="{data}">
            <Button
              icon="pi pi-pencil"
              class="p-button-rounded p-button-success p-mr-2"
              @click="edit(data.id)"
            />
            <Button
              icon="pi pi-trash"
              class="p-button-rounded p-button-warning p-mr-2"
              @click="borrar(data.id)"
            />
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>

<script>
import { apiGet, apiDelete } from '../../helpers/rest-api';

export default {
  data() {
    return {
      items: [],
    };
  },
  mounted() {
    this.getAll();
  },

  methods: {
    getAll() {
      apiGet('user').then((response) => (this.items = response.data));
    },

    borrar(index) {
      apiDelete('user/' + index).then(() => this.getAll());
    },

    edit(index) {
      this.$router.push('/usuarios/edit/' + index);
    },
  },
};
</script>

<style scoped lang="scss">
.cursor {
  cursor: pointer;
}

.empresa-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-active {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-inactive {
    background: #ffcdd2;
    color: #c63737;
  }
}
</style>
